// extracted by mini-css-extract-plugin
export default {"footer":"grFgzOOi","container":"DbAiNWYo","logoWrapper":"tGGW2T23","copyrightWrapper":"nDPOgUvI","copyright":"T3x_KFFo","policies":"yVe1Hsug","activeLink":"Z1EGNfvW"};